import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { DashboardOverview } from "@/api/types";
import { useDashboardRequest } from "./dashboard-request";

export function useDashboardOverview(slugOverride?: string) {
  const dashboard = useDashboardRequest(slugOverride);

  return useQuery({
    queryKey: dashboard.queryKey("overview"),
    queryFn: () =>
      api.get("dashboard/overview", dashboard.requestOptions()).json<DashboardOverview>(),
    staleTime: 60_000,
  });
}
